import React, { useEffect } from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import { View } from '@olxbr/design-system'
import { Button } from '@olxbr/ds-core'
import { Link, Modal, Alertbox } from '@olxbr/ds-web'
import { faleConosco } from '../../../settings/staticUrl'

const Container = styled(View)`
  display: flex;
  flex-direction: column;
`

const ButtonContent = styled(View)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-end;
`

const TitleModal = styled.span.attrs({ className: 'typo-body-medium' })`
  font-size: 20px;
  line-height: 26px;
  margin-top: 30px;
  text-align: center;
`

const TextModal = styled.span.attrs({ className: 'typo-body-medium' })`
  font-size: 16px;
  margin: 20px 0px;
  text-align: center;
`

const AlextboxContanainer = styled(View)`
  margin-bottom: 15px;
`

const LinkInstructionContent = styled(Link)`
  font-size: 10px;
  color: #4a4a4a;
`

export const SelfServiceModal = ({ open, onOpen, onSuccessChange, onCancelChange }) => {
  useEffect(() => {
    if (open) onOpen()
  }, [open])

  return (
    <Modal
      maxWidth="400px"
      maxHeight="570px"
      closeable={false}
      open={open}
      closeCallback={onCancelChange}
      preventCloseOnOutsideClick
    >
      <Container>
        <TitleModal className="font-bold">
          Tem certeza de que deseja <br />
          alterar seu telefone?
        </TitleModal>
        <TextModal>
          Ao continuar, você confirma que não tem <br />
          mais acesso ao telefone cadastrado.
        </TextModal>

        <AlextboxContanainer>
          <Alertbox>
            <span className="typo-body-small">
              Por segurança, este número {''}
              <span className="typo-body-small font-bold inline">
                não <br /> poderá ser cadastrado novamente {''}
              </span>
              <br /> pelos próximos 30 dias.
            </span>
          </Alertbox>
        </AlextboxContanainer>

        <Alertbox>
          <span className="typo-body-small">
            Caso esteja com problemas ao receber o código de validação para acesso,{''}
            <LinkInstructionContent href={faleConosco}>
              <span className="typo-body-small font-semibold"> entre em contato conosco.</span>
            </LinkInstructionContent>
          </span>
        </Alertbox>

        <ButtonContent>
          <Button type="button" onClick={onSuccessChange} className="w-full mb-1 mt-4">
            Confirmar alteração do telefone
          </Button>
          <Button type="button" variant="link" onClick={onCancelChange} className="w-full">
            Cancelar
          </Button>
        </ButtonContent>
      </Container>
    </Modal>
  )
}

SelfServiceModal.propTypes = {
  open: PropTypes.bool,
  onCancelChange: PropTypes.func,
  onSuccessChange: PropTypes.func,
  onOpen: PropTypes.func,
}
